export default "__VITE_ASSET__8e74cf6e__"